import React from 'react';
import type { VendorOrder } from '../types';

interface Props {
  data: VendorOrder[] | null;
}

export default function VendorOrdersTab({ data }: Props) {
  const getOrderStatusColor = (status: string) => {
    switch (status) {
      case 'ORDERED': return 'bg-green-100 text-green-700'; // 발주완료
      case 'IN_PROGRESS': return 'bg-blue-100 text-blue-700'; // 진행중
      case 'PENDING': return 'bg-yellow-100 text-yellow-700'; // 대기
      case 'CANCELLED': return 'bg-red-100 text-red-700'; // 취소
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  if (!data) return <div className="p-8 text-center text-gray-500">로딩중...</div>;

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-800">발주 내역</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">발주번호</th>
              <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">고객명</th>
              <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">서비스</th>
              <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">본식일</th>
              <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">발주일</th>
              <th className="px-6 py-3 text-right text-sm font-medium text-gray-700">금액</th>
              <th className="px-6 py-3 text-center text-sm font-medium text-gray-700">상태</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-6 py-10 text-center text-gray-500">발주 내역이 없습니다.</td>
              </tr>
            ) : (
              data.map((order) => (
                <tr key={order.orderIdx} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm font-medium text-blue-600">
                    {order.orderNo || `ORD-${order.orderIdx}`}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900">{order.customerName}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">{order.serviceName}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">{order.weddingDate}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">{order.orderDate}</td>
                  <td className="px-6 py-4 text-sm font-medium text-gray-900 text-right">
                    {order.totalAmount.toLocaleString()}원
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getOrderStatusColor(order.status)}`}>
                      {order.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}